
export type CreateOrderSession500 = {
  code?: string;
  error: string;
  success: boolean;
  timestamp?: string;
};
